export enum TaskType {
  ServiceTask = 'serviceTask',
  UserTask = 'userTask',
  IntermediateCatchEvent = 'intermediateCatchEvent',
}
